import React from "react";
import classes from "./Card.module.css";
import {FaLink} from "react-icons/fa"

const Card = (props) => {
  return (
    <div className={classes.card}>
      <div className={classes.box}>
        <img
        
          src={props.image}
          alt="CardImage"
        />
        <div className={classes.box_content}>
          <h3 className={classes.title}>{props.title}</h3>
          <span className={classes.post}>{props.technology}</span>
        </div>
        <ul className={classes.icon}>
          <li>
            <a target="_blank" rel="noreferrer" href={props.codebase}>
            <FaLink />
            </a>
          </li>
        </ul>
      </div>

      {/* <div className="card-body">
                    <h5 className="card-title title">{props.title}</h5>
                    <p className="card-text Content">{props.description}</p>
                    <a href={props.codebase} class="">More Info</a>
                </div> */}
    </div>
  );
};

export default Card;

// <div className="Card">
//  <div>
//        <img src={props.image} alt="Project Image" className="ImageProj" />
// </div>
//    <div>
//       <span className="title">{props.title}</span>
//          <span className="content">
//               {props.description}
//          </span>
//     </div>
//      <button type="button" className="btn btn-primary">
//        {props.codebase}
//      </button>
// </div>
